/* NOSKOO — scroll reveal + header hide-on-scroll. Skipped for prefers-reduced-motion. */
(function () {
  'use strict';
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function ready(fn) {
    if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var wide = window.matchMedia('(min-width: 750px)').matches;
    var groups = [
      '.nk-strip__inner > *', '.nk-head', '.nk-rail > .nk-card', '.nk-editorial__lead',
      '.nk-editorial__pair figure', '.nk-editorial__caption', '.nk-statement__inner > *',
      '.nk-newsletter__inner > *', '.nk-footer__cols > *'
    ];
    var targets = [];
    groups.forEach(function (sel) {
      if (!wide && sel.indexOf('.nk-rail') === 0) return; // keep the swipe rail untouched on phones
      document.querySelectorAll(sel).forEach(function (el) { if (targets.indexOf(el) === -1) targets.push(el); });
    });

    var counts = new Map();
    targets.forEach(function (el) {
      var n = counts.get(el.parentNode) || 0;
      counts.set(el.parentNode, n + 1);
      el.style.setProperty('--nk-i', Math.min(n, 5));
      el.classList.add('nk-reveal');
    });

    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px' });
      targets.forEach(function (el) { io.observe(el); });
    }

    var wrap = document.querySelector('.nk-header-wrap');
    if (wrap) {
      var last = window.scrollY, ticking = false;
      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          var y = window.scrollY, dy = y - last;
          var menuOpen = wrap.querySelector('.nk-menu[open]');
          if (y > 240 && dy > 8 && !menuOpen && !wrap.contains(document.activeElement)) wrap.classList.add('is-hidden');
          else if (dy < -8 || y < 120) wrap.classList.remove('is-hidden');
          last = y;
          ticking = false;
        });
      }, { passive: true });
    }
  });
})();
